
import qs from 'qs'
import axios from "axios"
import { toBase64 } from "js-base64";

let Ui = require('element-ui')
import router from "../router";

export default async function ReToken(error) {
  try {
    let data = await getNewToken();
    // console.log("data---", data)
    if (data.status != 200) {
      throw new Error("refresh token失效")
    }
    window.localStorage.setItem(
      'token', 'Bearer ' + data.data.access_token
    )
    window.localStorage.setItem(
      'refreshToken', data.data.refresh_token
    )
    // Ui.Message({
    //   message: "身份验证成功",
    //   type: 'success',
    //   duration: 2000,
    // })
    const res = await axios.request(error.config)
    return res;
  } catch (err) {
    Ui.Message({
      message: '登录会话已过期，请重新登录',
      type: 'error',
      duration: 5 * 1000
    })
    var uuid = window.localStorage.getItem('uuid')
    window.localStorage.clear();
    window.sessionStorage.clear();
    window.localStorage.setItem('uuid', uuid)
    router.replace({
      path: "/logistics/lgn"
    });
    // locatsion.reload()
    return err;
  }
}

async function getNewToken() {
  var refreshToken = localStorage.getItem('refreshToken');

  let res = await axios({
    url: '/oauth/token',
    method: 'post',
    // headers: {
    //   'Authorization': `Basic ${toBase64("usp:123")}`,
    //   'Content-Type': 'application/x-www-form-urlencoded'
    // },
    data: qs.stringify({
      grant_type: 'refresh_token',
      refresh_token: refreshToken
    })
  })
  return res
}
